import coefficient from './coefficient-step.vue';
import condition from './condition-step.vue';
import ingredient from './ingredient-step.vue';
import lookupEntity from './lookup-entity-step.vue';
import lookupUnit from './lookup-unit-step.vue';
import selectEntity from './select-entity-step.vue';

export const steps = {
  coefficient,
  ingredient,
  condition,
  lookupEntity,
  lookupUnit,
  selectEntity,
};
